import { BasicFormProps } from './BasicFormProps';
import { AbstractFormContentModel, CreativeFormData } from './FormContentModel';
import _ from 'lodash';
import { Creative, CreativeStatus } from 'core/creative/Creative';
import { Product } from 'core/product/Product';
import { CreativeSetupFlowPageModel } from 'containers/Creatives/CreativeSetupFlow/CreativeSetupFlowPageModelInterface';
import { ImageFormModel } from './ImageFormModel';
import { ProductNativeFormModel } from './ProductNativeFormModel';
import RichProductNativeForm from './RichProductNativeForm';

export type RichProductNativeFormProps = {
  readonly model: RichProductNativeFormModel;
  readonly hintModalData?: any;
  readonly setHintModalData: (modalData: any) => void;
} & BasicFormProps;

export class RichProductNativeFormModel extends AbstractFormContentModel {

  public needBannerUrl: boolean = false;
  public imageFormModel: ImageFormModel;
  public productNativeFormModel: ProductNativeFormModel;
  addLimitation?: (operate: string, limitationType: string, label: string, value: string) => void;

  constructor (
    public flowPageModel: CreativeSetupFlowPageModel,
    products: Product[] = [],
    public allowedImageSizes = [{
      width: 960,
      height: 320
    }]
  ) {
    super(flowPageModel);
    const imageWidthHeightMap = this.allowedImageSizes.reduce((map, size) => {
      const { width, height } = size;
      const heightsOfWidth = _.get(map, width, []);
      _.set(map, width, _.uniq([...heightsOfWidth, height]));
      return map;
    }, {} as { [key: string]: number[] });

    this.imageFormModel = new ImageFormModel(flowPageModel, imageWidthHeightMap);
    const initProducts = this.flowPageModel.type === 'edit'
      ? _.defaultTo(flowPageModel.state.creative?.basic.typeProperties.products, [])
      : products;
    this.productNativeFormModel = new ProductNativeFormModel(flowPageModel, initProducts);
  }

  setLimitationHook (addLimitation: (operate: string, limitationType: string, label: string, value: string) => void): void {
    this.addLimitation = addLimitation;
  }

  getInitTypeProperties (): any {
    return this.productNativeFormModel.getInitTypeProperties();
  }

  getFormContent = (): any => {
    return RichProductNativeForm;
  }

  getFormModelData (creative: Creative): CreativeFormData {
    const creativeBasic: any = _.omit(creative.basic, ['id', 'srcType', 'creativeValues']);
    const creativeValueString = _.get(creative, 'basic.creativeValues', '{}');
    const creativeValue = JSON.parse(creativeValueString);
    const imageUrl = _.get(creativeValue, 'images.0.imageUrl', creative.basic.bannerImageUrl);
    const width = _.get(creativeValue, 'images.0.w', this.allowedImageSizes[0].width);
    const height = _.get(creativeValue, 'images.0.h', this.allowedImageSizes[0].height);
    const medias = _.omitBy({
      image: _.omitBy({
        url: imageUrl,
        width,
        height
      }, _.isUndefined)
    }, _.isEmpty);
    const products =
      creative.basic.relatedProductInfo
        ?.filter((product) => product.state !== CreativeStatus.DEACTIVE)
        .map((product) => ({
          productId: product.id,
          ...product
        })) || [];
    return {
      basic: {
        ...creativeBasic,
        typeProperties: {
          products
        },
        medias
      }
    };
  }
}
